import { trackEvent } from "./analytics";

export function scrollToId(id, offset = -16) {
  const el = document.getElementById(id);
  if (!el) return;
  if (id === "reserver") trackEvent("InitiateCheckout", { content_name: "cta_prereserver" });
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export const IMAGES = {
  hero: "/images/life-blazer-walk.jpg",
  concept: "/images/life-cream-coffee.jpg",
  timeline: [
    { time: "07:45", label: "Partir travailler", src: "/images/life-blazer-walk.jpg" },
    { time: "10:30", label: "Traverser la ville", src: "/images/life-sneakers-legs.jpg" },
    { time: "12:45", label: "Aller déjeuner", src: "/images/life-cream-coffee.jpg" },
    { time: "17:30", label: "Faire les courses", src: "/images/life-back-sit.jpg" },
    { time: "19:00", label: "Promener son chien", src: "https://images.unsplash.com/photo-1643834068973-903e3c260269?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=940" },
  ],
};

export const COLORWAYS = [
  { key: "crema", name: "CREMA", hex: "#F3ECE3", border: "#E2D7C8", desc: "Nude essentiel" },
  { key: "pistacho", name: "PISTACHO", hex: "#CBD5C0", border: "#A8B89A", desc: "Équilibre naturel" },
  { key: "maquillaje", name: "MAQUILLAJE", hex: "#E6CECA", border: "#D4B3AD", desc: "Rose élégance" },
  { key: "negro", name: "NOIR", hex: "#1A1918", border: "#33312E", desc: "Performance intemporelle" },
];
